import { useReportingResource } from "@/hooks/useReportingResource";
import CompletionAssessmentForm from "./CompletionAssessmentForm";
import EvidencePanel from "./EvidencePanel";

export const ASSESSMENT_FIELDS = [
  ["indicator_assessment", "Indikator kelangsungan usaha"],
  ["assessment_period", "Periode penilaian manajemen"],
  ["management_assessment", "Evaluasi penilaian manajemen"],
  ["forecast", "Evaluasi proyeksi arus kas"],
  ["assumptions", "Pengujian asumsi"],
  ["sensitivity", "Analisis sensitivitas"],
  ["financing_availability", "Ketersediaan pendanaan"],
  ["covenant_matters", "Evaluasi persyaratan pinjaman"],
  ["mitigation", "Evaluasi rencana mitigasi"],
  ["disclosure_impact", "Dampak terhadap pengungkapan"],
  ["reporting_impact", "Dampak terhadap pelaporan auditor"],
  ["auditor_conclusion", "Kesimpulan auditor"],
  ["subsequent_events", "Peristiwa kemudian yang relevan"],
];

export default function GoingConcern({ id }) {
  const { data, error, busy, mutate, reload } = useReportingResource(id, "going-concern");
  const sources = useReportingResource(id, "evidence");
  if (error) return <div role="alert">{error}</div>;
  if (!data) return <div className="text-sm text-muted-foreground p-4">Memuat penilaian…</div>;
  return <><div role={sources.error ? "alert" : undefined}>{sources.error}</div><CompletionAssessmentForm fields={ASSESSMENT_FIELDS} title="Kelangsungan Usaha (Going Concern)" endpoint={`/engagements/${id}/going-concern`} prefix="gc" testId="going-concern-assessment" extraWork={{ indicators: data.indicators || [] }} key={`${id}:${data.mutation_version || 0}`} id={id} data={data} evidence={sources.data || []} reloadEvidence={sources.reload} reloadAssessment={reload} mutate={mutate} busy={busy} /><EvidencePanel key={id} id={id} phase="Kelangsungan Usaha" module="GoingConcern" /></>;
}
